<template>
  <div>
    <div class="demo-card-list">
      <div
        class="demo-commodit-card"
        v-for="(item, index) in dataList"
        :key="index"
      >
        <div class="demo-card-imgbox flex-center" @click="toDetail(item.id)">
          <img
            :src="item.picFile || require('@/assets/images/default_img.jpg')"
          />
        </div>
        <div class="demo-card-body-box">
          <el-tooltip
            :content="item.subjectName"
            placement="top"
            v-ak-tooltip-auto-show
          >
            <div
              class="title ellipsis-aRow"
              @click="toDetail(item.id)"
              v-html="
                eachColor(
                  item.subjectName,
                  searchName,
                  $store.state.read.searchText
                )
              "
            >
              <!-- {{ item.subjectName }} -->
            </div>
          </el-tooltip>

          <div class="demo-card-info">
            <div class="resource ellipsis-aRow">
              共{{ item.resourcesNun }}个资源
            </div>
            <div class="price">
              {{
                item.sellingPrice == 0 ||
                item.sellingPrice == "" ||
                item.sellingPrice == null
                  ? "免费"
                  : "￥" + item.sellingPrice
              }}
              <span class="yprice"
                >￥{{
                  item.price == null || item.price == "" ? 0 : item.price
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <noData style="margin-top: -45px" v-if="total == 0"></noData>
    <!-- <el-pagination style="float: right;"
		  v-show="total > 0"
		  @size-change="handleSizeChange"
		  @current-change="handleCurrentChange"
		  :current-page="queryParams.pageNum"
		  :page-sizes="[10, 20, 30, 40, 50]"
		  :page-size="queryParams.pageSize"
		  layout="total, sizes, prev, pager, next, jumper"
		  :total="total"
		>
		</el-pagination> -->
    <div class="pagination-box" v-show="total > 0">
      <el-pagination
        class="ou-pagination"
        background
        hide-on-single-page
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNum"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="queryParams.pageSize"
        layout="total, prev, pager, next, sizes, jumper, slot"
        :total="total"
      >
        <el-button @click="getList()" class="ou-page-go">GO</el-button>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { selectSubjects } from "@/api/index/index";
import noData from "@/components/noData.vue";
export default {
  data() {
    return {
      dataList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
    };
  },
  components: {
    noData,
  },
  props: {
    searchName: String,
    eachColor: Function,
  },
  methods: {
    getList(word = undefined) {
      //获取教学属性列表
      var Params = {
        ...this.queryParams,
        word1: word || undefined,
        word2: this.$store.state.read.searchText || undefined,
      };
      selectSubjects(Params).then((res) => {
        this.dataList = res.rows;
        this.total = res.total;
        this.$emit("settotal", "zttotal", res.total);
      });
    },
    //每页条数
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    //当前页面
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    toDetail(id) {
      this.$router.push({
        path: "/special/specialDetail",
        query: {
          subjectId: id,
        },
      });
    },
  },
};
</script>

<style scoped lang='scss'>
.demo-card-list {
  margin: 15px 0 30px;
  display: grid;
  grid-row-gap: 30px;
  column-gap: 20px;
  grid-template-columns: repeat(auto-fit, 320px);

  .demo-commodit-card {
    width: 320px;
    height: 324px;
    background: #ffffff;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    .demo-card-imgbox {
      width: 320px;
      height: 240px;
      cursor: pointer;

      img {
        // max-width: 100%;
        // max-height: 100%;
        // object-fit: scale-down;
        width: 100%;
        height: 100%;
      }
    }

    .demo-card-body-box {
      padding: 11px 10px 17px 14px;

      .title {
        margin-bottom: 12px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        width: 280px;
        cursor: pointer;
      }

      .title:hover {
        color: #1690ff;
        text-decoration: underline;
      }

      .demo-card-info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .resource {
          max-width: 155px;
          box-sizing: border-box;
          padding: 0 5px;
          min-width: 100px;
          height: 28px;
          background: #ffffff;
          border: 1px solid #0081ce;
          border-radius: 6px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #0081ce;
          text-align: center;
          line-height: 28px;
        }

        .price {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ff5353;

          .yprice {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            text-decoration: line-through;
            color: #999999;
          }
        }
      }
    }
  }
}

.el-pagination {
  margin-top: 10px;
  text-align: right;
}
</style>
